/* eslint-disable @typescript-eslint/camelcase */
import { Grid, makeStyles, Typography } from '@material-ui/core';
import DownloadIcon from '@material-ui/icons/GetApp';
import { Alert, AlertTitle } from '@material-ui/lab';
import Button from 'components/Button';
import i18n from 'i18n';
import { FormImportClients } from 'modules/clients/interfaces';
import React from 'react';
import formStyles from '../styles';

const useStyles = makeStyles(formStyles);

export interface Props {
  onSubmit: (values: FormImportClients) => void;
  onCancel: () => void;
}

export default function FormImportClient({ onSubmit, onCancel }: Props) {
  const classes = useStyles();
  const [file, setFile] = React.useState<File>();

  const onChangeFile = (event: React.ChangeEvent<HTMLInputElement>) => {
    const newFile = event.target.files?.[0];
    if (newFile) {
      setFile(newFile);
    }
  };

  const handleSubmit = () => {
    onSubmit({
      // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
      csv_file: file!,
    });
  };

  return (
    <Grid item container data-testid={'autosky-formimportclient'}>
      <Grid container spacing={2}>
        <Grid item xs={12}>
          <Alert severity="info" icon={false}>
            <AlertTitle color="secondary">
              <Typography className={classes.templateText}>
                {i18n.t('TEMPLATE_KEY')}
              </Typography>
            </AlertTitle>
            {i18n.t('CHOOSE_CSV_FILE_KEY')}
            <Button
              variant="outlined"
              color="secondary"
              startIcon={<DownloadIcon />}
              className={classes.buttonDownload}
              href="https://sky-static.s3.amazonaws.com/clientes/template_client.csv"
            >
              {i18n.t('DOWNLOAD_KEY')}
            </Button>
          </Alert>
        </Grid>

        <Grid item xs={12} className={classes.selectFile}>
          <input
            type="file"
            accept=".csv"
            id="btn-import-file"
            onChange={onChangeFile}
          />
        </Grid>

        <Grid container justify="flex-end" className={classes.buttonsBase}>
          <Grid container className={classes.buttonsAlign}>
            <Button
              id="submit-button"
              onClick={handleSubmit}
              disabled={!file}
              submitButton
            >
              {i18n.t('IMPORT_FILE_KEY')}
            </Button>
            <Button id="cancel-button" variant="outlined" onClick={onCancel}>
              {i18n.t('CANCEL_KEY')}
            </Button>
          </Grid>
        </Grid>
      </Grid>
    </Grid>
  );
}
